<footer class="footer-area bg-f7fafd">
  <div class="container">
    <div class="row">
      <div class="col-lg-2 col-md-6 col-sm-6">
        <div class="single-footer-widget">
          <div class="logo">
            <a routerLink="/"
              ><img
                data-sizes="auto"
                data-src="https://cdn.sanity.io/images/jizm7zxy/production/be216da9ba89e8e4e817902b0dcd565b380b5010-1516x583.png?fm=webp&q=90"
                width="200"
                class="lazyload"
                alt="wipperoz logo"
            /></a>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-6">
        <div class="single-footer-widget pl-5">
          <h3 i18n="@@companyFooterTitle">Company</h3>
          <ul class="list">
            <li><a i18n="@@aboutButton" [routerLink]="aboutRoute"> Wipperoz </a></li>
            <li><a i18n="@@termsConditionsButton" [routerLink]="aboutTermsRoute"> Terms and Conditions </a></li>
            <li><a i18n="@@privacyPolicyButton" [routerLink]="aboutPrivacyRoute"> Privacy Policy </a></li>
          </ul>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-6">
        <div class="single-footer-widget pl-5">
          <h3 i18n="@@usefulLinksFooterTitle">Explore</h3>
          <ul class="list">
            <li><a i18n="@@pricingButton" [routerLink]="pricingRoute"> Pricing </a></li>
            <li><a i18n="@@pressButton" [routerLink]="pressRoute"> Press </a></li>
            <li><a i18n="@@blogButton" [routerLink]="blogRoute"> Blog </a></li>
            <li><a i18n="@@helpButton" [href]="helpLink" target="_blank"> Help </a></li>
          </ul>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-6">
        <div class="single-footer-widget pl-5">
          <h3 i18n="@@LanguagesFooterTitle">Languages</h3>
          <ul class="list">
            <li>
              <a i18n="@@EnglishButton" (click)="onLanguageClick('en')" rel="nofollow" style="cursor: pointer">
                English
              </a>
            </li>
            <li>
              <a i18n="@@SpanishButton" (click)="onLanguageClick('es')" rel="nofollow" style="cursor: pointer">
                Español
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="single-footer-widget pl-5">
          <h3 i18n="@@contactFooterTitle">Contact</h3>
          <ul class="footer-contact-info">
            <li>
              <i-feather name="mail"></i-feather> Email: <a href="mailto:contact@wipperoz.com">contact@wipperoz.com</a>
            </li>
          </ul>
          <ul class="social-links">
            <li>
              <a href="https://click.wipperoz.com/facebook" class="facebook" rel="nofollow" target="_blank"
                ><i-feather name="facebook"></i-feather
              ></a>
            </li>
            <li>
              <a href="https://click.wipperoz.com/twitter" class="twitter" rel="nofollow" target="_blank"
                ><i-feather name="twitter"></i-feather
              ></a>
            </li>
            <li>
              <a href="https://click.wipperoz.com/instagram" class="instagram" rel="nofollow" target="_blank"
                ><i-feather name="instagram"></i-feather
              ></a>
            </li>
            <li>
              <a href="https://click.wipperoz.com/linkedin" class="linkedin" rel="nofollow" target="_blank"
                ><i-feather name="linkedin"></i-feather
              ></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-lg-12 col-md-12">
        <div class="copyright-area">
          <p i18n="@@footerRightsReserved">© {{ year }} Wipperoz Pty Ltd - ABN 36 623 500 603 - All Rights Reserved.</p>
          <ng-container *ngIf="showGoogle">
            <p i18n="@@footerRecaptcha">
              This site is protected by reCAPTCHA and the Google<a [href]="googlePrivacyPolicyLink" rel="nofollow">
                Privacy Policy </a
              >and<a [href]="googleTermsConditionsLink" rel="nofollow"> Terms of Service </a>apply.
            </p>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <img
    data-sizes="auto"
    data-src="https://cdn.sanity.io/images/jizm7zxy/production/f541fd0423250b2926da38a036662e0a8528810c-910x443.png?fm=webp&q=90"
    class="lazyload map"
    alt="map"
  />
  <div class="shape8 rotateme">
    <img
      data-sizes="auto"
      data-src="https://cdn.sanity.io/images/jizm7zxy/production/281de77eb843ec083d1df21eb5e7087c3ecf7c89-48x48.png?fm=webp&q=90"
      class="lazyload"
      alt="shape"
      width="24"
    />
  </div>
</footer>
